module.exports = __webpack_public_path__ + "static/awards-icon-8-283ccc428f7c91515dd1d36bd4fd2b0f.png";